/* eslint-disable */
import { DataEmoji } from './DataTypes'
import { emojiUnified } from './emojiUnified'
import { emojiVariations } from './emojiVariations'

export function emojiVariationUnified(
  emoji: DataEmoji,
  skinTone?: string,
): string | undefined {
  return skinTone
    ? emojiVariations(emoji).find((variation) => variation.includes(skinTone))
    : emojiUnified(emoji)
}
